export type StatusUser = 'active' | 'inactive';
export type UserRole = 'SimAdmin' | 'SimManager' | 'SimOperator';
export enum UserRoleEnum {
  SimAdmin = 'SimAdmin',
  SimManager = 'SimManager',
  SimOperator = 'SimOperator',
}

export enum UserStatus {
  Active = 'Active',
  Inactive = 'Inactive',
}

export type UserShortInfoDTO = {
  id: string;
  userName?: string;
  email: string;
  status: UserStatus;
  roles: UserRole[];
  createdOn: string;
  customerId?: string;
  customerName?: string;
  firstName?: string;
  emailVerified: boolean;
  lastName?: string;
};

export type UserDetailedInfoDTO = UserShortInfoDTO & {};

export type CreateUserCommand = {
  userName?: string;
  email?: string;
  customerId?: string;
  roles?: UserRole[];
};

export type UpdateAccountSettingsInput = {
  firstName?: string;
  lastName?: string;
  customerId: string;
};

export type EditUserCommand = {
  firstName: string;
  lastName: string;
  email: string;
  roles: UserRole[];
  status: UserStatus;
  customerId: string;
};

export type CreateOIDCInput = {
  alias: string;
  displayName: string;
  authorizationUrl: string;
  tokenUrl: string;
  clientId: string;
  clientSecret: string;
};

export type SSOType = 'saml' | 'oidc';

export type CreateSamlCInput = {
  alias: string;
  displayName: string;
  serviceProviderEntityId: string;
  samlEntityDescriptor: string;
};

export type SSOProvidersDTO = {
  providerId: SSOType;
  displayName: string;
  alias: string;
  enabled: boolean;
  trustEmail: boolean;
};

type OidcConfig = {
  syncMode?: string;
  clientId?: string;
  clientSecret?: string;
  authorizationUrl?: string;
  tokenUrl?: string;
};

type SamlConfig = {
  validateSignature?: string;
  signingCertificate?: string;
  postBindingLogout?: boolean;
  singleLogoutServiceUrl?: string;
  postBindingResponse?: boolean;
  idpEntityId?: string;
  loginHint?: boolean;
  metadataDescriptorUrl?: string;
  enabledFromMetadata?: boolean;
  postBindingAuthnRequest?: boolean;
  singleSignOnServiceUrl?: string;
  wantAuthnRequestsSigned?: boolean;
  addExtensionsElementWithKeyInfo?: boolean;
  artifactBindingResponse?: boolean;
  syncMode?: string;
  serviceProviderEntityId?: string;
};

type BaseSSOProviderDetails = {
  displayName: string;
  alias: string;
  enabled: boolean;
  trustEmail: boolean;
};

export type SamlProviderDetailsDTO = BaseSSOProviderDetails & {
  providerId: 'saml';
  config: SamlConfig;
};

export type OidcProviderDetailsDTO = BaseSSOProviderDetails & {
  providerId: 'oidc';
  config: OidcConfig;
};
